module.exports = __webpack_public_path__ + "4504d8f25075e4d7d650e20fd63e22dc.pdf";